// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2aIgC","dragIcon":"SortableItem_dragIcon__1HGkb","disabled":"SortableItem_disabled__36e-v"};